import { render, staticRenderFns } from "./FirebaseProjectsList.vue?vue&type=template&id=426b65bf&scoped=true"
import script from "./FirebaseProjectsList.vue?vue&type=script&lang=js"
export * from "./FirebaseProjectsList.vue?vue&type=script&lang=js"
import style0 from "./FirebaseProjectsList.vue?vue&type=style&index=0&id=426b65bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b65bf",
  null
  
)

export default component.exports